export default function formatCurrency(amount, currency) {
  const formatValue = parseFloat(amount).toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return `${formatValue} ${currency}`;
}
